import { useState } from "react";
import { api } from "../api/client";
import { TemplatesButton } from "./TemplatesButton";

export function Compose({ mailboxId, onClose }: { mailboxId: string; onClose: () => void }) {
  const [to, setTo] = useState("");
  const [subject, setSubject] = useState("");
  const [body, setBody] = useState("");
  const [sending, setSending] = useState(false);

  async function send() {
    if (!to.trim() || !body.trim()) return;
    setSending(true);
    try {
      await api.post(`/api/mailboxes/${mailboxId}/send`, { to, subject, body });
      onClose();
    } finally {
      setSending(false);
    }
  }

  return (
    <div
      className="gm-modal-scrim"
      onClick={onClose}
      onKeyDown={(e) => e.key === "Escape" && onClose()}
    >
      <div className="gm-modal gm-in" style={{ width: 640, padding: 22.4, display: "flex", flexDirection: "column", gap: 14 }} onClick={(e) => e.stopPropagation()}>
        <div style={{ display: "flex", alignItems: "center" }}>
          <div style={{ fontSize: 15, fontWeight: 500 }}>New message</div>
          <button className="btn btn-ghost" style={{ marginLeft: "auto" }} onClick={onClose}>Esc</button>
        </div>
        <input className="input" placeholder="To" value={to} onChange={(e) => setTo(e.target.value)} />
        <input className="input" placeholder="Subject" value={subject} onChange={(e) => setSubject(e.target.value)} />
        <div>
          <TemplatesButton mailboxId={mailboxId} onPick={setBody} />
        </div>
        <textarea className="input" style={{ minHeight: 200, resize: "vertical" }} value={body} onChange={(e) => setBody(e.target.value)} autoFocus />
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <button className="btn btn-primary" disabled={sending} onClick={send}>Send <span className="hint">⌘⏎</span></button>
          <span style={{ fontSize: 11, color: "var(--gm-text-4)" }}>Drafted in your voice from past replies.</span>
        </div>
      </div>
    </div>
  );
}
